// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d6e06c23","453":"48d6cd0a","455":"72447058","977":"a6949cdc"}[chunkId] + ".chunk.js";
};